/* eslint-disable react/prop-types */
import {useLocation} from 'react-router-dom'

import hoistNonReactStatics from 'hoist-non-react-statics'
import PropTypes from 'prop-types'

export const withThirdPartiesParam = (Component, displayName) => {
  const WrappedComponent = props => {
    // Always call useLocation hook (React Router v7)
    // This is safe because we're always in RR7 context now
    const rrLocation = useLocation()

    // Use RR7 location, with fallback to props for compatibility
    const location = rrLocation || props.location || props.router?.location

    // Parse query params from location.search
    const searchParams = new URLSearchParams(location?.search || '')
    const thirdparties = searchParams.get('thirdparties') || 'true'
    const loadThirdParties = JSON.parse(thirdparties)

    return <Component {...props} loadThirdParties={loadThirdParties} />
  }

  WrappedComponent.displayName = Component.displayName || displayName
  WrappedComponent.propTypes = {
    location: PropTypes.object,
    router: PropTypes.object
  }

  return hoistNonReactStatics(WrappedComponent, Component)
}
